"use strict";

var _interopRequireDefault = require("/Users/xudong/bs_workspace/RuoYi-Vue/hss_-warning_-h5/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
var _moment = _interopRequireDefault(require("moment"));
var _Calendar = _interopRequireDefault(require("@/components/Calendar"));
var _Select = _interopRequireDefault(require("@/components/Select"));
var _common = require("@/api/common");
var _default = exports.default = {
  name: 'FiveHardSearch',
  components: {
    Calendar: _Calendar.default,
    Select: _Select.default
  },
  data: function data() {
    return {
      show: false,
      chooseTimeList: [{
        text: '本周',
        value: 0
      }, {
        text: '上周',
        value: 1
      }, {
        text: '本月',
        value: 2
      }, {
        text: '上月',
        value: 3
      }, {
        text: '本学期',
        value: 4
      }, {
        text: '自定义',
        value: 5
      }],
      //   五困生筛选
      fiveHardTypeList: [{
        text: '全部',
        value: ''
      }, {
        text: '行为',
        value: '7'
      }, {
        text: '心理',
        value: '1'
      }, {
        text: '学业',
        value: '2'
      }, {
        text: '经济',
        value: '3'
      }, {
        text: '思想',
        value: '6'
      }],
      //学院下拉
      collegeColumns: ['学生处（学生工作部）', '水利与环境工程学院', '经济与管理学院 '],
      // 年级下拉
      yearColumns: ['2023', '2022', '2021', '2020', '2019'],
      chooseTimeActive: 0,
      //选中-选择时间
      fiveHardTypeAcitve: 0,
      //选中-五困生类型

      className: undefined,
      //班级名称
      collegeVal: undefined,
      //学院-选中值
      yearVal: undefined,
      //年级-选中值
      startDate: undefined,
      //开始时间
      endDate: undefined,
      //结束时间
      sign: undefined,
      //五困生类型

      fiveHardTPathList: ['/fiveHard', '/collegeMsg', '/gradeMsg', '/instructorMsg'] //需要显示五困生筛选的页面
    };
  },
  methods: {
    openActionSheet: function openActionSheet() {
      this.show = true;
    },
    //选中的的日期范围
    dataRange: function dataRange(startDate, endDate) {
      this.startDate = startDate;
      this.endDate = endDate;
    },
    //筛选-触发选择时间
    timeClick: function timeClick(val) {
      this.chooseTimeActive = val;
    },
    //筛选-选择五困生类型
    fiveHardType: function fiveHardType(index, val) {
      this.sign = val;
      this.fiveHardTypeAcitve = index;
    },
    //下拉选中值
    selectConfirm: function selectConfirm(val, type) {
      if (type === 'college') {
        this.collegeVal = val;
      } else {
        this.yearVal = val;
      }
    },
    //确定
    confirmClick: function confirmClick() {
      var _this = this;
      if (this.chooseTimeActive === 0) {
        //本周
        var weekOfDay = parseInt((0, _moment.default)().format('E')); //计算今天是这周第几天
        this.startDate = (0, _moment.default)((0, _moment.default)().startOf('day').subtract(weekOfDay - 1, 'days').toDate()).format('YYYY-MM-DD');
        this.endDate = (0, _moment.default)((0, _moment.default)().startOf('day').subtract(weekOfDay - 7, 'days').toDate()).format('YYYY-MM-DD');
      } else if (this.chooseTimeActive === 1) {
        //上周
        var today = (0, _moment.default)().startOf('week'); // 获取本周的起始日期
        this.startDate = (0, _moment.default)(today.clone().subtract(1, 'week').startOf('week').add(1, 'day')).format('YYYY-MM-DD');
        this.endDate = (0, _moment.default)(today.clone().subtract(1, 'week').endOf('week').add(1, 'day')).format('YYYY-MM-DD');
      } else if (this.chooseTimeActive === 2) {
        //本月
        this.startDate = (0, _moment.default)((0, _moment.default)().month((0, _moment.default)().month()).startOf('month').valueOf()).format('YYYY-MM-DD');
        this.endDate = (0, _moment.default)((0, _moment.default)().month((0, _moment.default)().month()).endOf('month').valueOf()).format('YYYY-MM-DD');
      } else if (this.chooseTimeActive === 3) {
        //上月
        this.startDate = (0, _moment.default)((0, _moment.default)().month((0, _moment.default)().month() - 1).startOf('month').valueOf()).format('YYYY-MM-DD');
        this.endDate = (0, _moment.default)((0, _moment.default)().month((0, _moment.default)().month() - 1).endOf('month').valueOf()).format('YYYY-MM-DD');
      } else if (this.chooseTimeActive === 4) {
        (0, _common.teachingTime)().then(function (res) {
          var data = res.data.data;
          _this.startDate = data[0].nyr;
          _this.endDate = data[data.length - 1].nyr;
        });
      }
      setTimeout(function () {
        if (_this.fiveHardTPathList.includes(_this.$route.path)) {
          //五困生统计
          _this.$bus.emit('fiveHardDbs', _this.startDate, _this.endDate, _this.sign);
        } else if (_this.$route.path === '/warningStu') {
          //预警学生
          _this.$bus.emit('warningStuDbs', _this.startDate, _this.endDate);
        }
        _this.closeClick();
      }, 500);
    },
    //重置
    resetClick: function resetClick() {
      this.chooseTimeActive = 0;
      this.fiveHardTypeAcitve = 0;
      this.startDate = undefined;
      this.endDate = undefined;
      this.sign = undefined;
      this.className = undefined;
      this.collegeVal = undefined;
      this.yearVal = undefined;
      //  this.$refs['collegeSelect'].value = ''
      // this.$refs['yearSelect'].value = ''
    },
    //关闭
    closeClick: function closeClick() {
      this.show = false;
      this.chooseTimeActive = 0;
      this.fiveHardTypeAcitve = 0;
    }
  }
};